module.exports = __webpack_public_path__ + "static/media/ant1.31c62a15.png";